/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 */

/**
 * Banner info feedback icon (16px).
 * Used in manage roster temp access info banner — styled with feedbackIcon + feedbackIconInfo.
 *
 * @file BannerInfoIcon.jsx
 * @author Anuja Gaikwad
 * @since 2.3.4
 */

import React from 'react';
import { SvgIcon } from '@mui/material';

function BannerInfoIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16ZM8.44466 6.22266C8.69012 6.22266 8.88911 6.42164 8.88911 6.6671V12.0004C8.88911 12.2459 8.69012 12.4449 8.44466 12.4449H7.55577C7.31031 12.4449 7.11133 12.2459 7.11133 12.0004V6.6671C7.11133 6.42164 7.31031 6.22266 7.55577 6.22266H8.44466ZM8.44466 3.55566C8.69012 3.55566 8.88911 3.75465 8.88911 4.00011V4.889C8.88911 5.13446 8.69012 5.33344 8.44466 5.33344H7.55577C7.31031 5.33344 7.11133 5.13446 7.11133 4.889V4.00011C7.11133 3.75465 7.31031 3.55566 7.55577 3.55566H8.44466Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export default BannerInfoIcon;
